
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Link, useNavigate } from 'react-router-dom';

export default function CreateNewButton(props) {
    /*
    const navigate = useNavigate();

    const onClick = () => {
        //props.onClick
        navigate("create", { relative: "path" });
    }
    */

    return (
        <Tooltip title='Create New'>
            {/* <Link to="create" relative='path'> */}
        <IconButton
            size="sm"
            color="neutral"
            variant="outlined"
            // color={props.color ?? "neutral"}
            // variant="soft"
            component={Link}
            to="create"
            relative="path"
            sx={theme => ({
                bgcolor: 'background.surface',
                /*
                bgcolor: theme.palette[props.color ?? "neutral"][600],// 'background.surface'
                color: '#fff',
                */
            })}
            >
            <AddRoundedIcon />
        </IconButton>
        {/* </Link> */}
        </Tooltip>
    );
}
